(() => {
  if (window.yi2cPetGuideBound) return;
  window.yi2cPetGuideBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pet-copy]');
    if (!button) return;
    const panel = button.closest('.yp-prompt-panel');
    const text = panel.querySelector('.yp-prompt').textContent;
    const status = panel.querySelector('[role="status"]');
    button.disabled = true;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(text);
      status.textContent = 'Full prompt copied.';
    } catch {
      const fallback = panel.querySelector('.yp-manual');
      fallback.hidden = false;
      const textarea = fallback.querySelector('textarea');
      textarea.value = text;
      textarea.focus();
      textarea.select();
      status.textContent = 'Select and copy the full prompt below.';
    } finally {
      button.disabled = false;
    }
  });
})();
